<div class="flow-toolbar" #toolbar>
    <div class="start-buttons" #startButtons>
        <ng-content select="[slot='start']"></ng-content>
    </div>

    <div class="title">{{ title }}</div>

    <div class="end-buttons" #endButtons>
        <ng-content select="app-toolbar-button[slot='end']"></ng-content>
    </div>
</div>
